import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";


// Async thunk to fetch member user data
export const fetchMemberUserData = createAsyncThunk('Data/fetchMemberUserData', async () => {

    const res = await HttpClient.requestData("user", "GET", {});
    return res.data;

});
// Async thunk to fetch SINGLE member user data
export const fetchSingleMemberUserData = createAsyncThunk('Data/fetchSingleMemberUserData', async (id) => {

    const res = await HttpClient.requestData("single-user/" + id, "GET", {});
    return res?.data;

});
// offer Category
export const OfferCategoryData = createAsyncThunk('Data/OfferCategoryData', async () => {

    const res = await HttpClient.requestData("offer-category", "GET", {});
    return res?.data;

});
// View Offer
export const viewOffer = createAsyncThunk('Data/viewOffer', async () => {
    const res = await HttpClient.requestData("offer", "GET", {});
    return res?.data
})
// total-voucher-issued
export const totalVoucherIssued = createAsyncThunk('Data/totalVoucherIssued', async () => {
    const res = await HttpClient.requestData("total-voucher-issued", "GET", {});
    return res?.data
})
// total-voucher-issued
export const totalVoucherRedeem = createAsyncThunk('Data/totalVoucherRedeem', async () => {
    const res = await HttpClient.requestData("total-voucher-redeem", "GET", {});
    return res?.data
})
// total-vendor
export const totalVendor = createAsyncThunk('Data/total-vendor', async () => {
    const res = await HttpClient.requestData("total-vendor", "GET", {});
    return res?.data
})

// Offer slice
const offerSlice = createSlice({
    name: "OfferData",
    initialState: {
        status: 'idle',
        error: '',
        memberData: [],
        singleMemberData: [],
        offerCategory: [],
        ViewOffersData: [],
        totalVoucherIssuedData:'',
        totalVoucherRedeemData:'',
        totalVendorData:''
    },
    reducers: {
        // Add reducers here if needed
    },
    extraReducers: (builder) => {
        builder
            //...................fetchMemberUserData.....................
            // Pending case for fetchMemberUserData
            .addCase(fetchMemberUserData.pending, (state) => {
                state.status = 'loading';
                state.error = ''; // Reset error
            })
            // Fulfilled case for fetchMemberUserData
            .addCase(fetchMemberUserData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.memberData = action.payload;
            })
            // Rejected case for fetchMemberUserData
            .addCase(fetchMemberUserData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // ..............SingleMemberData...............
            .addCase(fetchSingleMemberUserData.pending, (state) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(fetchSingleMemberUserData.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.singleMemberData = action.payload
            })
            .addCase(fetchSingleMemberUserData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            //...................OfferCategoryData.....................
            // Pending case for OfferCategoryData
            // .addCase(OfferCategoryData.pending, (state) => { 
            //     state.status = 'loading';
            //     state.error = ''; 
            // });
            .addCase(OfferCategoryData.pending, (state, action) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(OfferCategoryData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.offerCategory = action.payload;
            })
            .addCase(OfferCategoryData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            //View Offer Data
            .addCase(viewOffer.pending, (state, action) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(viewOffer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ViewOffersData = action.payload;
            })
            .addCase(viewOffer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            //totalVoucherIssued
            .addCase(totalVoucherIssued.pending, (state, action) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(totalVoucherIssued.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalVoucherIssuedData = action.payload;
            })
            .addCase(totalVoucherIssued.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            //totalVoucherRedeem
            .addCase(totalVoucherRedeem.pending, (state, action) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(totalVoucherRedeem.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalVoucherRedeemData = action.payload;
            })
            .addCase(totalVoucherRedeem.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            //totalVendor
            .addCase(totalVendor.pending, (state, action) => {
                state.status = "Loading"
                state.error = ""
            })
            .addCase(totalVendor.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.totalVendorData = action.payload;
            })
            .addCase(totalVendor.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

    }

});

// export const { } = offerSlice.actions
export default offerSlice.reducer;
